import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.262 2.387h-1.32a2.087 2.087 0 0 0-3.89 0h-1.32A2.719 2.719 0 0 0 2.022 5.1v7.14a2.719 2.719 0 0 0 2.71 2.71h6.53a2.721 2.721 0 0 0 2.72-2.71V5.1a2.721 2.721 0 0 0-2.72-2.713Zm-5.13 1.5h.53a.755.755 0 0 0 .75-.75.585.585 0 0 1 1.17 0 .749.749 0 0 0 .75.75h.53v.49h-3.73Zm6.35 8.35a1.216 1.216 0 0 1-1.22 1.21h-6.53a1.208 1.208 0 0 1-1.21-1.21V5.1a1.2 1.2 0 0 1 1.11-1.2v1.23a.749.749 0 0 0 .75.75h5.23a.755.755 0 0 0 .75-.75V3.9a1.2 1.2 0 0 1 1.12 1.2Zm-1.73-2.53a.749.749 0 0 1-.75.75h-1.25v1.25a.75.75 0 1 1-1.5 0v-1.25H6a.75.75 0 1 1 0-1.5h1.25v-1.25a.75.75 0 0 1 1.5 0v1.25H10a.755.755 0 0 1 .752.75Z';
const draw24px =
  'M17,3.249h-2.32a2.787,2.787,0,0,0-5.37,0h-2.3A3.751,3.751,0,0,0,3.262,7v10.91a3.751,3.751,0,0,0,3.75,3.75H17a3.751,3.751,0,0,0,3.75-3.75V7A3.751,3.751,0,0,0,17,3.249Zm-8.25,1.5h1.21a.749.749,0,0,0,.75-.75,1.29,1.29,0,1,1,2.58,0,.743.743,0,0,0,.75.75h1.21V6.3h-6.5Zm10.5,13.16A2.253,2.253,0,0,1,17,20.159H7.012a2.253,2.253,0,0,1-2.25-2.25V7a2.253,2.253,0,0,1,2.25-2.25h.24v2.3A.749.749,0,0,0,8,7.8h8a.755.755,0,0,0,.75-.75v-2.3H17A2.253,2.253,0,0,1,19.252,7ZM15.752,14a.749.749,0,0,1-.75.75h-2.25V17a.75.75,0,0,1-1.5,0v-2.25H9a.75.75,0,0,1,0-1.5h2.25V11a.75.75,0,0,1,1.5,0v2.25H15A.755.755,0,0,1,15.752,14Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ClipboardPlusIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'clipboardPlus')) as IconWithRender;

ClipboardPlusIcon.displayName = 'ClipboardPlusIcon';
ClipboardPlusIcon.propTypes = Icon.propTypes;
ClipboardPlusIcon.renderIcon = (props) => <ClipboardPlusIcon {...props} />;
export default ClipboardPlusIcon;
